module.exports = __webpack_public_path__ + "img/control.5ebf9f3f.svg";